import { render, staticRenderFns } from "./leaderDetailAssess.vue?vue&type=template&id=273069ce&scoped=true"
import script from "./leaderDetailAssess.vue?vue&type=script&lang=js"
export * from "./leaderDetailAssess.vue?vue&type=script&lang=js"
import style0 from "./leaderDetailAssess.vue?vue&type=style&index=0&id=273069ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273069ce",
  null
  
)

export default component.exports